import api from "./api";
import cargoService, {
    getCargoViewById,
    postCargo,
    getsCargoViewSearchBasic,
    annulCargo,
    activeCargo
} from "./cargoService";

export const GetCargoViewById = getCargoViewById;
export const PostCargo = postCargo;
export const GetsCargoViewSearchBasic = (descripcion, idEstado, idGrupoCargo = 0) =>
    getsCargoViewSearchBasic(descripcion, idEstado, idGrupoCargo);
export const AnnulCargo = annulCargo;
export const ActiveCargo = activeCargo;

export default cargoService;
